import { render, staticRenderFns } from "./ProgramAddonsDialog.vue?vue&type=template&id=4fc30c2c&scoped=true"
import script from "./ProgramAddonsDialog.vue?vue&type=script&lang=js"
export * from "./ProgramAddonsDialog.vue?vue&type=script&lang=js"
import style0 from "./ProgramAddonsDialog.vue?vue&type=style&index=0&id=4fc30c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc30c2c",
  null
  
)

export default component.exports